import BaseController from "confinus_ui/base_controller";
import axios from "axios";

export default class extends BaseController {
  static targets = ["preview", "submitButton"];
  static values = { previewUrl: String };

  async dateSelected() {
    const endDateInput = this.element.querySelector(
      "input[name='end_date']",
    ) as HTMLInputElement;
    const startDateInput = this.element.querySelector(
      "input[name='start_date']",
    ) as HTMLInputElement;

    const endDate = endDateInput?.value;
    const startDate = startDateInput?.value;

    if (!endDate) {
      this.previewTarget.innerHTML =
        '<p class="text-muted mb-0">Select an end date to preview orders</p>';
      (this.submitButtonTarget as HTMLButtonElement).disabled = true;
      return;
    }

    try {
      const response = await axios.get(this.previewUrlValue, {
        params: { start_date: startDate || null, end_date: endDate },
      });

      const { count, start_date, end_date } = response.data;

      let dateRange: string;
      if (start_date) {
        dateRange = `from ${start_date} to ${end_date}`;
      } else {
        dateRange = `up to and including ${end_date}`;
      }

      if (count === 0) {
        this.previewTarget.innerHTML = `<p class="text-warning mb-0">No orders found with delivery date ${dateRange}</p>`;
        (this.submitButtonTarget as HTMLButtonElement).disabled = true;
      } else {
        this.previewTarget.innerHTML = `<p class="text-success mb-0">This will confirm <strong>${count}</strong> order${count === 1 ? "" : "s"} with delivery date ${dateRange}</p>`;
        (this.submitButtonTarget as HTMLButtonElement).disabled = false;
      }
    } catch (error) {
      this.previewTarget.innerHTML =
        '<p class="text-danger mb-0">Error loading preview</p>';
      (this.submitButtonTarget as HTMLButtonElement).disabled = true;
    }
  }

  declare readonly previewTarget: HTMLElement;
  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly previewUrlValue: string;
}
